const e = {
  name: "RevenueProtect",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30.1,2.6c-9.2-3.4-19.2-3.4-28.2,0C0.7,3,0,4.1,0,5.3v19.2c0,3.7,1.9,7.2,5,9.2l8.5,5.5l0,0
			c0.7,0.5,1.6,0.7,2.5,0.7c0.8,0,1.6-0.2,2.3-0.6l0,0l8.1-4.6c3.4-2,5.5-5.6,5.5-9.5V17h-2v8.2c0,3.2-1.7,6.2-4.5,7.8l-8.1,4.7l0,0
			C16.9,37.9,16.5,38,16,38c-0.5,0-1-0.1-1.4-0.4l0,0l-8.5-5.5C3.6,30.4,2,27.6,2,24.5V5.3c0-0.4,0.2-0.8,0.6-0.9
			c8.5-3.2,18-3.2,26.8,0l0,0C29.7,4.6,30,4.9,30,5.4v0.8c0,0.3-0.1,0.5-0.3,0.7L13.3,23.3l1.4,1.4L31.1,8.3C31.7,7.7,32,7,32,6.2
			V5.4C32,4.1,31.2,3,30.1,2.6z"/>
		<path class="st0" d="M12,27c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1C11.6,26,12,26.4,12,27z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as RevenueProtect
};
